import { render, staticRenderFns } from "./vue-form-builder.vue?vue&type=template&id=276bc3f1&scoped=true&"
import script from "./vue-form-builder.vue?vue&type=script&lang=js&"
export * from "./vue-form-builder.vue?vue&type=script&lang=js&"
import style0 from "./vue-form-builder.vue?vue&type=style&index=0&id=276bc3f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276bc3f1",
  null
  
)

export default component.exports